module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "warp"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("../assets/images/index.jpg")
    }
  }), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "line-height": "100px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('a', {
    attrs: {
      "href": "http://yjglt.henan.gov.cn/"
    }
  }, [_vm._v("河南省应急管理厅")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('a', {
    attrs: {
      "href": "http://yjglj.sh.gov.cn/"
    }
  }, [_vm._v("上海应急管理")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.mem.gov.cn/"
    }
  }, [_vm._v("中华人民共和国应急管理部")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('a', {
    attrs: {
      "href": "http://ha.119.gov.cn/"
    }
  }, [_vm._v("河南消防")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a8fd7182"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard.vue
// module id = 1190
// module chunks = 2